import React from 'react';
import Navbar from '../../components/layout/Navbar';
import HeroSection from '../../components/layout/HeroSection';
import InfoSection from '../../components/layout/InfoSection';
import StatsSection from '../../components/layout/StatsSection';
import AboutSection from '../../components/layout/AboutSection';
import Footer from '../../components/layout/Footer';
import ScienceBackground from '../../components/layout/ScienceBackground';

const Home = () => {
  return (
    <div className="font-sans bg-slate-50 min-h-screen text-slate-800 overflow-x-hidden selection:bg-rose-500 selection:text-white relative">
      <ScienceBackground />
      <Navbar />
      <HeroSection />
      <InfoSection />
      <StatsSection />
      <AboutSection />
      <Footer />
    </div>
  );
};

export default Home;
